import React from 'react';
import { 
  Box, 
  Typography, 
  Grid, 
  useMediaQuery, 
  useTheme,
} from '@mui/material';

import manuals from '../assets/images/manuals.png';
import videos from '../assets/images/video-tutorials.png';
import files from '../assets/images/files.png';
import questions from '../assets/images/questions.png';
import search from '../assets/images/search.png';
import features from '../assets/images/features.png';

interface BenefitItem {
  title: string;
  description: string;
  icon: React.ReactNode;
}

const CustomerBenefits: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const benefits: BenefitItem[] = [
    {
      title: "Manuales de Uso",
      description: "Ten acceso de manera online a manuales actualizados y guías de uso para tu S10 ERP",
      icon: manuals
    },
    {
      title: "Videos Tutoriales",
      description: "Mira videos instructivos clasificados por módulo o tipo de aplicación.",
      icon: videos
    },
    {
      title: "Archivos Descargables",
      description: "Descarga de manera segura documentos y archivos ejecutables en tu computador",
      icon: files
    },
    {
      title: "Preguntas Frecuentes",
      description: "Revisa nuestra sección de preguntas más frecuentes hechas por otros usuarios",
      icon: questions
    },
    {
      title: "Búsquedas por Temas",
      description: "Realiza búsquedas sugeridas dentro del portal para facilitar la ubicación de consultas",
      icon: search
    },
    {
      title: "Nuevos Lanzamientos",
      description: "Infórmate de nuevos lanzamientos y actualizaciones en el ERP",
      icon: features
    }
  ];

  return (
    <Box sx={{ 
    //   py: 8,
      px: isMobile ? 2 : 6,
    //   backgroundColor: '#f9f9f9'
    }}>
      <Box sx={{ 
        mb: 6,
        px: isMobile ? 0 : 4,
        maxWidth: '800px',
        mx: 'auto',
        textAlign: 'center'
      }}>
        <Typography 
          variant="overline" 
          component="div" 
          sx={{
            color: 'orange',
            fontWeight: 'bold',
            fontSize: '0.9rem',
            mb: 1,
            display: 'block'
          }}
        >
          BENEFICIOS A CLIENTES
        </Typography>
        <Typography 
          variant="h4" 
          component="h2"
          sx={{
            fontWeight: 'bold',
            color: 'black',
            mb: 2
          }}
        >
          Cómo te ayuda este Portal
        </Typography>
      </Box>

      <Grid container spacing={4} justifyContent="center">
        {benefits.map((benefit, index) => (
          <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex' }}>
            <Box sx={{
              p: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              height: '100%',
              '&:hover': {
                transform: 'translateY(-5px)',
                transition: 'all 0.3s ease'
              }
            }}>
              <Box sx={{ 
                mb: 2,
                width: "80px",
                height: "80px",
                backgroundImage: `url(${benefit.icon})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center'
            }}/>
              
              <Typography 
                variant="h6" 
                component="h3" 
                sx={{ 
                  fontWeight: 'bold',
                  color: theme.palette.primary.main,
                  mb: 2
                }}
              >
                {benefit.title}
              </Typography>
              
              <Typography 
                variant="body1"
                sx={{
                  color: theme.palette.text.secondary
                }}
              >
                {benefit.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CustomerBenefits;